import {
    ButtonAppearanceList,
    Colors,
    Outline,
    PillAppearanceList,
    PillColorList as PillColors,
} from '@ptml/design-system';
import { Theme } from './themes.types';

export const ORDERLY_THEME: Theme = {
    outline: {
        tiny: Outline.orderly.tiny,
        small: Outline.orderly.small,
        default: Outline.orderly.medium,
        hover: Outline.orderly.large,
        transparent: Outline.transparent,
    },
    sidebar: {
        background: Colors.Orderly.Gunmetal100,
        boxShadow: Colors.White,
        button: {
            colorLeft: Colors.Orderly.Sunset50,
            colorRight: Colors.Orderly.Sunset30,
            hoverLeft: Colors.Orderly.Sunset50,
            hoverRight: Colors.Orderly.Sunset30,
            hover: Colors.Orderly.Gunmetal90,
            selected: Colors.Orderly.Gunmetal100,
            color: Colors.White,
        },
        link: {
            color: Colors.Orderly.Gunmetal0,
            disabled: Colors.Grey70,
        },
    },
    error: {
        color: Colors.Orderly.Coral70,
        background: Colors.Orderly.Coral10,
    },
    comments: {
        backgroundColor: Colors.Orderly.Gunmetal10,
        icon: {
            color: Colors.Orderly.Gunmetal90,
            backgroundColor: Colors.Orderly.Gunmetal20,
        },
    },
    summarycart: {
        expandCollapseToggle: {
            color: Colors.Orderly.IceBlue70,
        },
        instantOrderCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.NEW,
                isSubtleVariant1: false,
                color: Colors.Orderly.IceBlue60,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.IceBlue10,
                borderColor: Colors.Orderly.IceBlue30,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: 'unset',
                iconColor: 'unset',
            },
        },
        quoteRequestCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.INPROGRESS,
                isSubtleVariant1: false,
                color: Colors.Orderly.Mauve80,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.Mauve10,
                borderColor: Colors.Orderly.Mauve20,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: 'unset',
                iconColor: 'unset',
            },
        },
        draftOrderCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.INPROGRESS,
                isSubtleVariant1: true,
                color: PillColors.PURPLE07,
                fontColor: Colors.Purple50,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.Gunmetal0,
                borderColor: Colors.Orderly.Gunmetal20,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: 'unset',
                iconColor: 'unset',
            },
        },
        actionRequiredCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.SUCCESS,
                isSubtleVariant1: false,
                appearanceVariant2: PillAppearanceList.WARNING,
                isSubtleVariant2: false,
                color: Colors.Orderly.Turquoise70,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.Gunmetal10,
                borderColor: Colors.Orderly.Gunmetal20,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: Colors.Orderly.Sunset10,
                iconColor: Colors.Orderly.Sunset60,
            },
        },
        confirmOrderCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.INPROGRESS,
                isSubtleVariant1: false,
                color: Colors.Orderly.Mauve80,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.Mauve10,
                borderColor: Colors.Orderly.Mauve20,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: 'unset',
                iconColor: 'unset',
            },
        },
        orderedCard: {
            background: Colors.Orderly.Gunmetal0,
            highlight: 'rgb(120 207 193 / 100%)', // Orderly.Turquoise30
            border: {
                color: Colors.Orderly.Gunmetal10,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.SUCCESS,
                isSubtleVariant1: false,
                color: Colors.Orderly.Turquoise70,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: Colors.White,
            },
            tableVariant: 'plain',
            orderTotal: {
                color: Colors.Orderly.Gunmetal90,
                fontColor: Colors.White,
            },
            summaryFooter: {
                background: Colors.Orderly.Gunmetal10,
                borderColor: Colors.Orderly.Gunmetal20,
            },
            cancelOrderHeaderIcon: {
                backgroundColor: Colors.Orderly.Sunset10,
                iconColor: Colors.Orderly.Sunset60,
            },
        },
        noResultCard: {
            background: Colors.Orderly.Gunmetal0,
            border: {
                color: Colors.Orderly.Gunmetal20,
            },
            pill: {
                appearanceVariant1: PillAppearanceList.NEW,
                isSubtleVariant1: false,
                color: Colors.Orderly.IceBlue60,
                fontColor: Colors.White,
            },
            button: {
                appearance: ButtonAppearanceList.PRIMARY,
                secondaryAppearance: ButtonAppearanceList.SECONDARY,
            },
            icon: {
                color: 'unset',
            },
            tableVariant: 'plain',
            orderTotal: {
                color: 'unset',
                fontColor: 'unset',
            },
            summaryFooter: {
                background: 'unset',
                borderColor: 'unset',
            },
            cancelOrderHeaderIcon: {
                backgroundColor: 'unset',
                iconColor: 'unset',
            },
        },
    },
    jobDetail: {
        partHeader: {
            instantOrderBackgroundColor: Colors.Orderly.IceBlue20,
            otherOrderBackgroundColor: Colors.Orderly.Mauve10,
        },
        partOptionRow: {
            priceMatchIconBackgroundColor: Colors.Orderly.Mauve50,
            priceMatchIconColor: Colors.White,
            priceMatchBackgroundColor: Colors.Orderly.Mauve10,
            packageSuggestionBackgroundColor: Colors.Orderly.Gunmetal10,
            normalBackgroundColor: Colors.Orderly.IceBlue10,
            unselectedBackgroundColor: Colors.Orderly.Gunmetal0,
            skeletonBackgroundColor: Colors.Grey01,
            insurerNote: {
                informationMessageAssemblyBackgroundColor:
                    Colors.Orderly.IceBlue0,
                informationMessageNormalBackgroundColor: Colors.White,
                informationMessageNormalBorderColor: Colors.Orderly.IceBlue10,
                informationMessageAssemblyBorderColor: Colors.Orderly.IceBlue20,
                informationIconOuterRingColor: 'rgba(34, 42, 46, 0.1)', // Orderly.Gunmetal100,
                informationIconInnerRingColor: 'rgba(34, 42, 46, 0.3)',
                informationIconColor: Colors.Orderly.Gunmetal100,
                warningMessageBackgroundColor: Colors.Orderly.Coral10,
                warningMessageBorderColor: Colors.Orderly.IceBlue10,
                warningIconOuterRingColor: 'rgba(188, 25, 25, 0.1)', // Orderly.Coral70
                warningIconInnerRingColor: 'rgba(188, 25, 25, 0.3)',
                warningIconColor: Colors.Orderly.Coral70,
            },
        },
        orderTotals: {
            borderColor: Colors.Orderly.IceBlue60,
            backgroundColor: Colors.Orderly.Gunmetal90,
            before: {
                instantOrderBorderColor: Colors.Orderly.IceBlue30,
                otherOrderBorderColor: Colors.Orderly.Mauve30,
            },
        },
        quotingNotification: {
            backgroundColor: Colors.Orderly.Mauve10,
            fontColor: Colors.Orderly.Mauve100,
        },
        vendorPriorityBadge: {
            primary: Colors.Orderly.Sunset30,
            secondary: Colors.Orderly.IceBlue30,
            tertiary: Colors.Orderly.Mauve30,
            textColor: Colors.Orderly.Gunmetal100,
        },
        hiddenPart: {
            fontColor: Colors.Orderly.Gunmetal30,
        },
        partComment: {
            textColor: Colors.Orderly.Gunmetal100,
            borderColor: Colors.Orderly.Gunmetal30,
        },
        adjustListPrice: {
            button: {
                hover: {
                    backgroundColor: Colors.Orderly.IceBlue30,
                },
            },
        },
        assemblies: {
            headerRow: {
                backgroundColor: Colors.Orderly.IceBlue90,
                borderColor: Colors.Orderly.Gunmetal30,
            },
        },
        excludePart: {
            iconColor: Colors.Orderly.Coral70,
            iconBackgroundColor: Colors.Orderly.Coral10,
            backgroundColor: Colors.Orderly.Gunmetal0,
        },
        actionRequired: {
            backgroundColor: Colors.Orderly.Sunset10,
            borderColor: Colors.Orderly.Sunset90,
            textColor: Colors.Orderly.Sunset70,
        },
        jobLocked: {
            backgroundColor: Colors.Orderly.Gunmetal100,
            borderColor: Colors.Orderly.Gunmetal100,
            textColor: Colors.Orderly.Gunmetal0,
            iconBackgroundColor: Colors.Orderly.IceBlue60,
        },
    },
    jobs: {
        actions: {
            color: Colors.Orderly.Gunmetal100,
            quoting: Colors.Orderly.Gunmetal100,
        },
        search: {
            textColor: Colors.Orderly.Gunmetal100,
            backgroundColor: Colors.Orderly.Gunmetal0,
            heading: Colors.Orderly.Gunmetal70,
            headingDivider: Colors.Orderly.Gunmetal50,
            searchResultsDivider: Colors.Orderly.Gunmetal20,
        },
    },
    returns: {
        successIconColor: Colors.Orderly.Turquoise70,
        totals: {
            textColor: Colors.Orderly.Gunmetal0,
            background: Colors.Orderly.Gunmetal90,
        },
    },
    header: {
        actOnBehalf: {
            backgroundColor: Colors.Orderly.IceBlue20,
            textColor: Colors.Orderly.Gunmetal100,
        },
    },
    ticketingCart: {
        backgroundColor: Colors.Orderly.Gunmetal0,
        borderLeftColor: Colors.Orderly.Gunmetal20,
        header: {
            headerTextColor: Colors.Orderly.Gunmetal100,
            closeIconColor: Colors.Orderly.Gunmetal100,
            closeIconHoverOutline: Outline.tiny,
        },
    },
};
